/*!
 * Written by Addy Osmani
 * Copyright (C) 2014 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
'use strict';

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var cheerio = require('cheerio');

var types = {
  stylesheets: {
    selector: 'link[rel*="stylesheet"]',
    attribute: 'href'
  },
  scripts: {
    selector: 'script',
    attribute: 'src'
  },
  imports: {
    selector: 'link[rel="import"]',
    attribute: 'href'
  },
  preload: {
    selector: 'link[rel*="preload"][as="style"]',
    attribute: 'href'
  },
  links: {
    selector: 'a',
    attribute: 'href'
  },
  images: {
    selector: 'img',
    attribute: 'src'
  },
  styles: {
    selector: 'style',
    method: 'text'
  }
};

function oust(src, type, raw) {
  if (typeof src !== 'string' || !type) {
    throw new Error('`src` and `type` required');
  }

  var validTypes = Object.keys(types);
  var typeArray = Array.isArray(type) ? type : [type];

  var _iterator = _createForOfIteratorHelper(typeArray),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _type = _step.value;

      if (!validTypes.includes(_type)) {
        throw new Error("Invalid `type` value \"".concat(_type, "\". Choose one of: ").concat(validTypes.join(', ')));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var chosenTypes = typeArray.map(function (type) {
    return _objectSpread(_objectSpread({}, types[type]), {}, {
      type: type
    });
  });
  var selector = chosenTypes.map(function (type) {
    return type.selector;
  }).join(', ');
  var $ = cheerio.load(src);
  return Array.prototype.map.call($(selector), function (element) {
    var $element = $(element);
    var chosenType = chosenTypes.find(function (type) {
      return $element.is(type.selector);
    });
    var value = '';

    if (chosenType.method && $element[chosenType.method]) {
      value = $element[chosenType.method]();
    } else if (chosenType.attribute) {
      value = $element.attr(chosenType.attribute);
    }

    if (raw) {
      return {
        $el: $element,
        type: chosenType.type,
        value: value
      };
    }

    return value;
  });
}

module.exports = function (src, type) {
  return oust(src, type, false);
};

module.exports.raw = function (src, type) {
  return oust(src, type, true);
};